import { render, staticRenderFns } from "./WalletTransferModal.vue?vue&type=template&id=5bb8c726&"
import script from "./WalletTransferModal.vue?vue&type=script&lang=js&"
export * from "./WalletTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports